export const JWT_TOKEN = "VINAMA_COMPETITION_ADMIN_TOKEN"

export const USER_ROLE = {
  SUPER_ADMIN: "super_admin",
  AUTHENTICATED: "authenticated",
  PUBLIC: "public",
}

export const STAFF_ROLES = [USER_ROLE.SUPER_ADMIN]
